import React from "react";
import {Button, Form, Modal, Spinner} from "react-bootstrap";
import {useState} from "react";
import axios from "axios";
import {useSelector} from "react-redux";

const CreateSDS = () => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const [sds_name, set_sds_name] = useState('N/A');
    const [manufacturer, set_manufacturer] = useState('N/A');
    const [revision_date, set_revision_date] = useState('N/A');
    const [sds_document, set_sds_document] = useState('N/A');

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const reload = () => window.location.reload();

    const AddSDSInfo = async () => {
        if (sds_name === 'N/A') {
            alert("Please Enter SDS name")
        } else if (manufacturer === 'N/A') {
            alert("Please Enter Manufacturer")
        } else if (revision_date === 'N/A') {
            alert("Please Enter Revision Date.")
        } else if (sds_document === 'N/A') {
            alert("Please Attach SDS For Upload.")
        } else {
            setDoneSubmitting(true)
            let formField = new FormData()

            formField.append('sds_name', sds_name)
            formField.append('manufacturer', manufacturer)
            formField.append('revision_date', revision_date)
            formField.append('sds_document', sds_document)

            await axios({
                method: 'post',
                url: `https://homesafetysolutions.pythonanywhere.com/api/sds/create/`,
                // url: `http://127.0.0.1:8000/api/sds/create/`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${userInfo.token}`
                },
                data: formField,
            }).then(() => {
                setShow(false);
            })
        }
        setDoneSubmitting(false)
    }

    return (
        <div className={'formcontainer'}>
            <Button variant="danger" onClick={handleShow}>
                Create SDS Sheet
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                size="xl"
                onExit={reload}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Create SDS Sheet {sds_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId={'sds_name'}>
                            <Form.Label>Required: SDS Name</Form.Label>
                            <Form.Control
                                // aria-required={true}
                                type={'text'}
                                placeholder={"SDS Name:"}
                                name={'sds_name'}
                                value={sds_name}
                                onChange={(e) => set_sds_name(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId={'manufacturer'}>
                            <Form.Label>Manufacturer</Form.Label>
                            <Form.Control
                                type={'text'}
                                placeholder={"Manufacturer"}
                                name={'manufacturer'}
                                value={manufacturer}
                                onChange={(e) => set_manufacturer(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId={'revision_date'}>
                            <Form.Label>Revision Date:</Form.Label>
                            <Form.Control
                                type={'date'}
                                placeholder={"Revision Date"}
                                value={revision_date}
                                onChange={(e) => set_revision_date(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId={'sds_document'}>
                            <Form.Label>SDS Document:</Form.Label>
                            <Form.Control
                                type={'file'}
                                onChange={(e) => set_sds_document(e.target.files[0])}
                            />
                        </Form.Group>
                        <br/>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    {/*<Button variant="primary" onClick={handleClose}>*/}
                    {/*    Save Changes*/}
                    {/*</Button>*/}
                    {
                        doneSubmitting
                            ?
                            (
                                <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                            )
                            :
                            (
                                <Button className={'btn btn-success'} onClick={AddSDSInfo}>
                                    Add SDS
                                </Button>
                            )
                    }
                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default CreateSDS

// import React from 'react';
//
// const CreateSDS = () => {
//     return(
//         <div className={"banner_heading"}>
//             <h1>Safety Data Sheets (SDS)</h1>
//             <h2>Create SDS</h2>
//             <hr />
//             <h3>All SDS'S:</h3>
//         </div>
//     )
// };
//
// export default CreateSDS;
